/* eslint-disable import/prefer-default-export */
import styled from '@emotion/styled';

const getPaddingWithBorder = (padding) => {
  const [topBottom, rightLeft] = padding.split(' ');
  return `calc(${topBottom} - 1px) calc(${rightLeft} - 1px)`;
};

export const Pill = styled.div`
  padding: ${({ look, size }) =>
    look.borderColor ? getPaddingWithBorder(size.padding) : size.padding};
  line-height: ${({ size }) => size.lineHeight};
  border-radius: 4px;
  font-size: ${({ size }) => size.fontSize};
  font-weight: ${({ size }) => size.fontWeight};
  box-sizing: border-box;

  color: ${({ look }) => look.color};
  background-color: ${({ look }) => look.backgroundColor};
  ${({ look }) => look.borderColor && `border: 1px solid ${look.borderColor};`}
`;
